import React from "react";
import Layout from "../../dashboard-layouts/layout/Layout";

const DashboardLayout = () => <Layout />;

export default DashboardLayout;
